import { useEffect } from 'react';
import { debounce } from 'src/components/muiTheme/utils';

export const usePostMessages = (): void => {
  useEffect(() => {
    const location = window.location.pathname;
    const element = document.getElementById('root') || document.body;
    let lastSentHeight: number | null = null;
    // Function that sends the current height to the parent window
    const sendHeight = (): void => {
      requestAnimationFrame(() => {
        const height = Math.max(
          element.scrollHeight,
          element.offsetHeight,
          element.clientHeight
        );
        if (lastSentHeight! - height > 20 || lastSentHeight! - height < -20) {
          window.parent.postMessage({ frameHeight: height, location }, '*'); // Replace '*' with the parent page's origin for better security
        }

        lastSentHeight = height;
      });
    };

    const throttledSendHeight = debounce(sendHeight, 200);
    // Observer the DOM for changes and send height
    const observer = new ResizeObserver(throttledSendHeight);
    observer.observe(element, {});

    // Create an observer to monitor changes in the content size

    // Call throttledSendHeight when the window is resized
    window.addEventListener('resize', throttledSendHeight);
    window.addEventListener('load', sendHeight);

    // Send initial height
    sendHeight();

    // Cleanup event listeners and observer when the component unmounts
    return () => {
      window.removeEventListener('resize', throttledSendHeight);
      observer.disconnect();
    };
  }, []);
};
